import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FilterHeaderComponent } from '../filter-header/filter-header.component';
import { BaseFilterComponent } from '../filter/base-filter.component';

@Component({
  selector: 'vectronic-multi-select-filter',
  templateUrl: './multi-select-filter.component.html',
  styleUrls: ['./multi-select-filter.component.scss'],
  imports: [FilterHeaderComponent, MatSelectModule, MatFormFieldModule, ReactiveFormsModule],
})
export class MultiSelectFilterComponent extends BaseFilterComponent {}
